<div class="row">

    <div class="col-lg-12 mb-2 mb-sm-4">
        <div>
            <button
                type="button"
                class="btn btn-light border-bottom btn-light-custom"
                style="padding: 3px 10px"
                (click)="clickEvent()"
            >
                <span style="position: relative; top: 3px">
                    <i class="material-icons">arrow_left</i>
                </span>
                <span style="position: relative; top: -3px">Πίσω</span>
            </button>
        </div>
        <ng-container *ngIf="breadcrumb$ | async as bc">
          <div class="row">
          <div [ngClass]="{'col-md-7': bc?.image, 'col-md-12': !bc?.image}">

            <span class="d-inline-block mt-2">
              <span id="bref">
                  <span class="breadcrumb-title-small">{{
                      bc?.titleSmall
                  }}</span>
              </span>
          </span>
          <h3 class="mt-2">
              <span class="breadcrumb-title-large">{{ bc?.titleLarge }}</span>
          </h3>
          <span class="black whitespace-pre-line" [innerHTML]="bc?.desc"> </span>
          </div>

          <ng-container *ngIf="bc?.image">
            <div class="col-md-5 breadcrumb-image">
              <a href="https://www.ktimatologio.gr/el" target="_blank">
                <img width="80%" height="80%" src="{{bc.image}}" />
              </a>
            </div>
          </ng-container>
        </div>
        </ng-container>
    </div>
</div>
